/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Ref} from "vue-property-decorator";
import {getShareFunctionsList, getRuleListByFunctionsId, setNewRule, setRuleById, getRuleById} from '@/api/authority'
import {UserModule} from '@/store/modules/user'
import {getDeparmentList, getUserList} from '@/api/common'
import subMenu from "@/components/submenu/index.vue";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import DepartmentTree from '../DepartmentTree/Index.vue'

// 类型定义
interface TreeNode {
    id: string | number
    name: string
    children?: TreeNode[]
    [key: string]: any
}

interface DepartmentInfo {
    department: {
        name: string
        detail: any
        id: string | number
    }
    departmentId: string | number
}

@Component({
    components: {
        subMenu,
        MoreUsersFilter,
        DepartmentTree
    }
})
export default class AuthoritySetting extends Vue {
    formRules = {
        types: [{required: true, message: '选择规则类型', trigger: 'change'}],
        functionsIdList: [{required: true, message: '请选择数据内容', trigger: 'change'}],
        belongTo: [{required: true, message: '请选择数据内容归属', trigger: ['change', 'blur']}],
        directorUserId: [{required: true, message: '请选择To Who', trigger: 'change'}],
    }
    // ------ 变量 ------
    titleName = '创建新规则'
    editId: null
    stopShareId: null
    // 数据内容归属
    rangeSelectShow = false
    inRange = '部门'
    checkDeparmentInfo: any = [] // 选中的部门信息
    checkUserInfo: any = [] // 选中的员工信息，主要用来回显在适用范围的输入框内，与后台返回的deparmentList、userList数据结构基本一致，方便渲染
    searchName = '' // 搜索的关键字

    roleList: any = [] // 角色列表
    loading = false
    roleId = 0 // 当前操作的角色ID
    functionsList: any = [] // 权限列表
    functionsList3: any = [] // 数据列表
    dialogDataShow: false
    dialogVisible = false
    addDialogShow = true
    tableData = []
    tableKey = Math.random()
    tableRandom = Math.random()
    tableLoading = false
    page = 1
    limit = 20
    total = 0
    tableHeadFilter = {
        marketCooperationName: '',  //合作伙伴名称
        directorUserIdList: [], //负责人id
        status: '', //返佣状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
    }
    repeatStudentWeixinList: any = []
    formData: any = {
        id: null,
        types: null,
        functionsIdList: [],
        belongTo: null,
        belongToId: null,
        userId: null,
        role: null,
        directorUserId: '',
        deparment: '',
        deparmentId: NaN,
        deparmentName: ''
    }
    formEditData: any = {
        id: null,
        types: null,
        functionsId: null,
        belongTo: null,
        belongToId: null,
        userId: null,
        role: null,
        directorUserId: '',
        deparment: '',
        deparmentId: NaN,
        deparmentName: '',
        belongToName: '',
        userName: '',
    }

    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    checkRangeEditDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    checkRangeUserList: Array<string> = [] // 适用范围内选中的员工 id
    deparmentList: any = [] // 部门列表
    userList = []
    stopshareShow = false // 删除角色弹框
    editDialog = false
    dirId = ''
    accessibleList: any = []
    departmentIdList = []
    visible = false
    directorUserName = ''
    disBtn = false
    disEditBtn = false
    filter_userId = ''
    newRuleloading = false
    editRuleloading = false
    // refs
    @Ref() readonly tree!: DepartmentTree
    @Ref() readonly edittree!: DepartmentTree
    // 数据
    private treeCheckTimer: number | null = null
    private treeChangeTimer: number | null = null
    // To Who
    // get userLists() {
    //     return UserModule.userList
    // }
    // ------ 生命周期 ------
    created() {
        this.initRoleList()
        // this.getUserList()
        this.getDeparment()
    }


    pageChange(page: number) {
        this.page = page
        this.getTableData()
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    openNew() {
        this.dialogVisible = true
        this.disBtn = false
    }

    handleShow() {
        this.rangeSelectShow = false
    }

    // ------ 方法 ------
    onSearchName() {
        if (this.formEditData.belongTo == '0') this.getDeparment(this.formEditData.belongTo)
        // if(this.formEditData.belongTo == '1') this.getUserList(this.formEditData.belongTo)
    }

    // 编辑-数据内容归属
    belongChange(val) {
        this.formEditData.belongTo = val
        this.formEditData.belongToId = null
        this.visible = true
    }

    // 编辑-数据内容归属
    customerChange(val) {
        this.formEditData.belongToId = val
    }

    // 新增-数据内容归属
    addBelongChange(val) {
        this.formData.belongTo = val
        this.formData.belongToId = null
    }

    addPeopleChange(val) {
        // 员工部门选择

        this.formData.belongToId = val
        this.$forceUpdate()
    }

    async getDeparment(name?: string) {
        const data: any = await getDeparmentList({name})
        this.deparmentList = data
    }

    // async getUserList(name?: string ) {
    //     const data: any = await getUserList({ name })
    //     this.userList = data
    //
    // }
    //选择规则类型
    typesChange(val) {
        this.formData.types = val
    }

    typesEditChange(val) {
        this.formEditData.types = val
    }

    //数据内容
    dataContentChange(val) {
        this.formData.functionsIdList = val
    }

    dataContentChangeEdit(val) {
        this.formEditData.functionsId = val
    }

    handleAddCancel() {
        // this.formData = {}
        this.formData.types = null
        this.formData.departmentList = []
        this.checkDeparmentInfo = []
        this.checkUserInfo = []
        this.formData.belongTo = ''
        this.formData.belongToId = null
        this.formData.deparmentName = ''
        this.checkRangeDepartmentList = []
        this.formData.functionsIdList = []
        this.formData.directorUserId = ''
        this.closeDialog()
    }

    addRole() {
        (this.$refs.ruleForm as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {
                this.newRuleloading = true
                const obj = {
                    id: null,
                    types: this.formData.types,
                    functionsIdList: this.formData.functionsIdList,
                    belongTo: this.formData.belongTo,
                    belongToId: String(this.formData.belongToId),
                    userId: String(this.formData.directorUserId),
                    role: this.formData.types == '0' ? this.formData.role : null,
                }
                for (const key in obj) {
                    if (!obj[key] || obj[key].length <= 0) {
                        delete obj[key]
                    }
                }
                this.disBtn = true
                setNewRule(obj).then(() => {
                    this.$message.success('新建规则成功')
                    this.closeDialog()
                    this.pageChange(1)
                    this.formData.types = ''
                    this.formData.functionsIdList = []
                    this.formData.belongTo = ''
                    this.formData.belongToId = null
                    this.formData.deparmentName = ''
                    this.formData.directorUserId = ''
                    this.formData.role = ''
                    this.checkRangeDepartmentList = []
                    this.newRuleloading = false
                }).catch((err: Error) => {
                    this.newRuleloading = false
                    this.disBtn = false
                })
            }
        })
    }

    async editRole() {
        this.editRuleloading = true
        const arr = []
        arr.push(this.formEditData.functionsId)
        const obj = {
            id: this.editId,
            types: this.formEditData.types,
            functionsIdList: arr,
            belongTo: this.formEditData.belongTo,
            belongToId: String(this.formEditData.belongToId),
            userId: String(this.formEditData.userId),
            role: this.formEditData.types == '0' ? this.formEditData.role : null,
        }
        for (const key in obj) {
            if (!obj[key] || obj[key].length <= 0) {
                delete obj[key]
            }
        }
        this.disEditBtn = true
        await setNewRule(obj).then(() => {
            this.$message.success('编辑规则成功')
            this.editRuleloading = false
            this.editDialog = false
            this.formData.belongToId = null
            this.getTableData()
        }).catch(() => {
            this.disEditBtn = false
            this.editRuleloading = false
        })

    }

    async clickEditButton(row) {

        this.editDialog = true
        this.disEditBtn = false
        this.editId = null
        this.editId = row.id
        let name = ''
        // let realName = ''
        // 调用详情接口渲染数据
        const data: any = await getRuleById(this.editId)
        this.formEditData = data.rule

        // this.formEditData.directorUserId = data.rule.userId
        this.formEditData.userId = data.rule.userId
        this.formEditData.userName = data.rule.userRealName

        // this.userLists.forEach(item => {
        //     if (item.id == this.formEditData.directorUserId) {
        //         this.directorUserName = item.realName
        //     }
        // })

        if (data.rule.belongTo == '0') {
            this.formEditData.belongToId = Number(data.rule.belongToId);
            this.checkRangeEditDepartmentList = [this.formEditData.belongToId]
            this.formEditData.deparmentName = data.rule.departmentName
            this.deparmentList.map((item: any) => {
                if (item.id == this.formEditData.belongToId) {
                    name = item.name
                    this.formEditData.deparmentName = item.name
                }
            })
            this.checkDeparmentInfo.push({
                department: {
                    id: data.rule.belongToId,
                    name: name
                },
                departmentId: data.rule.belongToId
            })

        } else if (data.rule.belongTo == '1') { // 员工
            // this.formEditData.directorUserId = data.rule.directorUserId
            this.formEditData.belongToId = data.rule.belongToId
            this.formEditData.belongToName = data.rule.belongToUserRealName
            // this.userList.map((item: any) => {
            //     if((item.id == this.formEditData.belongToId)){
            //         realName = item.realName
            //     }
            // })
            this.checkUserInfo.push({
                user: {
                    id: data.rule.belongToId,
                    realName: data.rule.belongToUserRealName
                },
                userId: data.rule.belongToId
            })
        }
    }

    // 停止共享确定事件
    async setRuleById() {
        await setRuleById({id: this.stopShareId, action: '0'})
        setTimeout(() => {
            this.$message.success('停止共享成功')
            this.stopshareShow = false
        }, 1000)
        this.getTableData()
    }

    handleStop(row) {
        this.stopShareId = row.id
        this.stopshareShow = true
    }

    handleRun(row) {
        this.handleRules(row.id)
    }

    async handleRules(id) {
        // '0'-停止, '1'-运行
        await setRuleById({id: id, action: '1'})
        this.$message.success('运行共享成功')
        this.getTableData()
    }

    // 获取左侧角色列表
    async initRoleList() {
        const data: any = await getShareFunctionsList()
        this.roleList = data.functionsList

        this.roleId = this.roleList[0].id
        // this.roleName = this.roleList[0].name
        this.getRoleAuthority(this.roleId)
        this.getTableData()
    }

    // 点击左侧菜单事件--点击传不同角色进行列表刷新 并进行模块隐藏显示
    async getRoleAuthority(id: number) {
        this.loading = true
        this.roleId = id
        this.getTableData()
        this.loading = false
    }

    // 列表
    async getTableData() {
        this.loading = true
        const data: any = await getRuleListByFunctionsId(delNullProperty({
            functionsId: this.roleId,
            userId: this.filter_userId,
            limit: this.limit,
            page: this.page
        }))
        this.tableData = data.ruleList
        this.total = data.allNum
        this.loading = false
        this.tableRandom = Math.random()
    }

    // 新增弹窗关闭回调
    closeDialog() {
        this.dialogVisible = false
    }

    // ToWho change
    directorUserIdChange(e) {
        this.formData.directorUserId = e.id
    }

    editUserIdChange(val) {

        this.formEditData.directorUserId = val
    }


// 完全保留原有treeCheck逻辑，只加防抖
    treeCheck(data: any, list: any) {
        if (this.treeCheckTimer) clearTimeout(this.treeCheckTimer)

        this.treeCheckTimer = setTimeout(() => {
            // 完全使用原来的逻辑
            const treeRef = (this.tree as any)?.treeRef
            if (!treeRef) return

            let thisNode = treeRef.getNode(data.id)
            const keys = [data]

            if (thisNode?.checked) {
                // 单选逻辑：当前节点若被选中，取消勾选父节点
                for (let i = thisNode.level; i > 1; i--) {
                    if (thisNode.parent) {
                        treeRef.setChecked(thisNode.parent, false)
                        if (!thisNode.parent.checked) {
                            thisNode = thisNode.parent
                            keys.unshift(thisNode.data)
                        }
                    }
                }
            }
        }, 50) as unknown as number
    }

    // 完全保留原有treeChange逻辑，只加防抖
    treeChange(data: any, checked: boolean, indeterminate: boolean) {
        if (!checked) return

        if (this.treeChangeTimer) clearTimeout(this.treeChangeTimer)

        this.treeChangeTimer = setTimeout(() => {
            const treeComponent: any = this.tree
            if (!treeComponent) return

            // 关键：单选逻辑 - 只选中当前节点
            treeComponent.setCheckedKeys([data.id])
            const res = treeComponent.getCheckedNodes()

            // 完全保留原有的数据处理逻辑
            const arrDeptId: any[] = []
            res.forEach((item: any) => {
                arrDeptId.push({
                    department: {
                        name: item.name,
                        detail: null,
                        id: item.id
                    },
                    departmentId: item.id
                })
            })

            this.checkDeparmentInfo = arrDeptId

            // 更新checkRangeDepartmentList
            this.checkRangeDepartmentList = []
            this.checkDeparmentInfo.forEach((item: any) => {
                this.checkRangeDepartmentList.push(item.departmentId)
            })

            this.departmentIdList = this.checkRangeDepartmentList
            this.formData.belongToId = this.departmentIdList[0]

            // 查找部门名称
            this.deparmentList.map((item: any) => {
                if (item.id == this.formData.belongToId) {
                    this.formData.deparmentName = item.name
                }
            })

            if (this.checkDeparmentInfo.length > 0) {
                this.formData.deparmentName = this.checkDeparmentInfo[0].department.name
            }
        }, 30) as unknown as number
    }

    // 编辑对话框复用相同方法
    treeEditCheck(data: any, list: any) {
        this.treeCheck(data, list)
    }

    treeEditChange(data: any, checked: boolean, indeterminate: boolean) {
        if (!checked) return

        // 防抖
        if (this.treeChangeTimer) clearTimeout(this.treeChangeTimer)

        this.treeChangeTimer = setTimeout(() => {
            const treeComponent: any = this.edittree
            if (!treeComponent) return

            // 单选
            treeComponent.setCheckedKeys([data.id], true)
            const res = treeComponent.getCheckedNodes()

            if (res.length > 0) {
                const selectedNode = res[0]

                // 关键修复：同时更新formEditData
                this.formEditData.belongToId = selectedNode.id
                this.formEditData.deparmentName = selectedNode.name  // 这里修复

                // 保持原有的数据处理（如果需要）
                const arrDeptId = []
                arrDeptId.push({
                    department: {
                        name: selectedNode.name,
                        detail: null,
                        id: selectedNode.id
                    },
                    departmentId: selectedNode.id
                })

                this.checkDeparmentInfo = arrDeptId
                this.checkRangeEditDepartmentList = [selectedNode.id]
            }
        }, 30) as unknown as number
    }


    beforeDestroy() {
        if (this.treeCheckTimer) clearTimeout(this.treeCheckTimer)
        if (this.treeChangeTimer) clearTimeout(this.treeChangeTimer)
    }
    changeFilterUserId(e) {
        this.filter_userId = e.id
        this.pageChange(1)
    }

    changeBelongToId(e) {
        this.formData.belongToId = e.id
    }

    changeEditBelongToId(e) {
        this.formEditData.belongToId = e.id
    }

    changedirectorUserName(e) {
        this.formEditData.userId = e.id
    }
}
